<!-- <div class="auth-wrapper-login">
    <div class="auth-panel-left" [class.auth-panel-left--dev]="!produccion">
        <span class="auth-blob auth-blob-1"></span>
        <span class="auth-blob auth-blob-2"></span>
        <span class="auth-blob auth-blob-3"></span>
        <span class="auth-blob auth-blob-4"></span>

        <div class="auth-brand-panel">
            <div class="auth-brand-logo">
                <img src="assets/images/logo-tsi-tres.png" alt="TSI" />
            </div>
            <h1 class="auth-brand-title">{{nombreProyecto}}</h1>
            <p class="auth-brand-subtitle">Plataforma integrada de gestión<br>empresarial</p>

            <div class="auth-brand-divider"></div>

            <div class="auth-brand-features">
                <div class="auth-brand-feature">
                    <span class="feat-dot"></span> Gestión de compras y logística
                </div>
                <div class="auth-brand-feature">
                    <span class="feat-dot"></span> Control financiero avanzado
                </div>
                <div class="auth-brand-feature">
                    <span class="feat-dot"></span> Reportes y análisis en tiempo real
                </div>
                <div class="auth-brand-feature">
                    <span class="feat-dot"></span> Integración con inteligencia artificial
                </div>
            </div>
        </div>
    </div>

    <div class="auth-panel-right" [class.auth-panel-right--dev]="!produccion">
        <div class="auth-panel-bg">
            <span class="auth-deco auth-deco-tl"></span>
            <span class="auth-deco auth-deco-br"></span>
        </div>

        <div class="auth-form-wrapper">
            <div>
                @if (!produccion) {
                <div>
                    <span class="auth-test-badge">
                        <span class="badge-dot"></span> ENTORNO DE PRUEBAS
                    </span>
                </div>
                }

                <div class="auth-card">
                    <h2 class="auth-card-title">Bienvenido de vuelta</h2>
                    <p class="auth-card-subtitle">Ingresa tus credenciales para continuar</p>

                    <form [formGroup]="authForm" id="loginform">

                        <div class="auth-field" [class.has-error]="validacion('ruc')">
                            <span class="auth-field-icon"><i class="fas fa-building"></i></span>
                            <input type="text" formControlName="ruc" class="auth-input" placeholder=" " maxlength="11"
                                id="f-ruc" autocomplete="off">
                            <label for="f-ruc" class="auth-label">RUC</label>
                        </div>
                        @if (validacion('ruc')) {
                        <p class="auth-error" @fadeInOut>Ingresar RUC</p>
                        }

                        <div class="auth-field" [class.has-error]="validacion('nomuser')">
                            <span class="auth-field-icon"><i class="fas fa-user"></i></span>
                            <input type="text" formControlName="nomuser" class="auth-input" placeholder=" " id="f-user"
                                autocomplete="off">
                            <label for="f-user" class="auth-label">Usuario</label>
                        </div>
                        @if (validacion('nomuser')) {
                        <p class="auth-error" @fadeInOut>Ingresar usuario</p>
                        }

                        <div class="auth-field" [class.has-error]="validacion('clave')">
                            <span class="auth-field-icon"><i class="fas fa-lock"></i></span>
                            <input [type]="showPassword() ? 'text' : 'password'" formControlName="clave"
                                class="auth-input" placeholder=" " id="f-clave" autocomplete="new-password">
                            <label for="f-clave" class="auth-label">Contraseña</label>
                            <button type="button" class="auth-toggle-pw" (click)="togglePassword()">
                                <i [class]="showPassword() ? 'fas fa-eye' : 'fas fa-eye-slash'"></i>
                            </button>
                        </div>
                        @if (validacion('clave')) {
                        <p class="auth-error" @fadeInOut>Ingresar clave</p>
                        }

                        <button class="auth-btn mt-2" [class.auth-btn--red]="!produccion" (click)="authUser()">
                            Ingresar
                        </button>

                        <div class="auth-links">
                            <a [ngClass]="produccion ? 'blue_contrasena' : 'red_contrasena'"
                                routerLink="/recuperar-clave">¿Olvidaste tu contraseña?</a>
                            <a [ngClass]="produccion ? 'blue_contrasena' : 'red_contrasena'"
                                routerLink="/clave-expirada">¿Contraseña vencida?</a>
                        </div>

                    </form>

                    <div class="auth-version">
                        <span>v{{versionApp}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> -->
<lib-auth-tsi
[production]="produccion"
[module]="nombreProyecto"
[versionApp]="versionApp"
[authForm]="authForm"
[aboutList]="aboutList"
[product]="module"
(loginEvent)="auth($event)"
(beforeInstall)="onBeforeInstall()"
></lib-auth-tsi>
